import { ResolveState } from '../../../common';
import { Updater } from '../../../upgrade/models/updater-interface';
import { ErrorResult } from '../../../upgrade/models/error-result';
import { Logger } from '../../utils/logger';

/**
 * the ObservableThrowUpdater error handler/updater.
 */
export class ObservableThrowUpdater implements Updater {
    /**
     * the update function.
     * @param fileData the file data.
     * @param error the error object.
     * @returns the updated file data.
     */
    public update(fileData: string, error: ErrorResult): Promise<string> {
        if (!fileData) {
            Logger.error(`Cannot find file data`);
        }

        const result = this.regexFixer(fileData);

        error.resolved = ResolveState.Resolved;
        return new Promise(resolve => resolve(result));
    }

    /**
     * the update function.
     * @param inputString the input file data string.
     * @returns the updated file data string.
     */
    private regexFixer(inputString: string): string {
        /**
         * const inputString = "return Observable.throw(new Error(this.strings.exportInvalidPath.format(currentChannelName)));";
         * to
         * const inputString = "return Observable.throw(() => new Error(this.strings.exportInvalidPath.format(currentChannelName)));";
         **/
        function replaceObservableThrow(_match, p1) {
            return `return throwError(() => (${p1}));`;
        }

        const regexPattern = /return\s+Observable\.throw\((new Error\(.*?\))\);/;

        const replacedString = inputString.replace(regexPattern, replaceObservableThrow);

        return this.importFixer(replacedString);
    }

    /**
     * the importFixer function.
     * @param inputString the input file data string.
     * @returns the updated file data string.
     */
    private importFixer(inputString: string): string {
        const importStatement = "import { throwError } from 'rxjs';\n";
        if (!inputString.includes(importStatement)) {
            inputString = "import { throwError } from 'rxjs';\n" + inputString;
        }

        return inputString;
    }
}
